export default (theme) => ({
    root: {},
    selectWrapper: {
        width: '100%',
    },
    contentLoader: {
        height: '100%',
    },
    content: {
        overflow: 'overlay',
        height: '100%',
        borderRadius: 4,
        borderTop: `16px solid ${theme.colors.grey[50]}`,
        borderBottom: `16px solid ${theme.colors.grey[50]}`,
    },
    notReady: {
        '& $content': {
            border: 'none',
        },
    },
    overlay: {
        zIndex: 1601,
    },
    optionsContainer: {
        display: 'flex',
        minHeight: '100%',
        boxSizing: 'border-box',
        backgroundColor: theme.colors.grey[50],
    },
    filters: {
        padding: '0 16px',
    },
    backButton: {
        color: theme.colors.actionMajor[450],
        '&:hover': {
            color: theme.colors.actionMajor[600],
        },
    },
    emptyContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    emptyIcon: {
        width: 48,
        height: 48,
        marginBottom: 16,
    },
    emptyText: {
        color: theme.colors.utility.textSecondary,
    },
    loader: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
});
